import { render, staticRenderFns } from "./TotalUsuariosCard.vue?vue&type=template&id=5604628a"
import script from "./TotalUsuariosCard.vue?vue&type=script&lang=ts"
export * from "./TotalUsuariosCard.vue?vue&type=script&lang=ts"
import style0 from "./TotalUsuariosCard.vue?vue&type=style&index=0&id=5604628a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports